interface TagProps {
  children: string;
  tone?: "primary" | "accent" | "secondary" | "neutral";
}

const toneMap: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700 border-primary-200",
  accent: "bg-accent-100 text-accent-900 border-accent-300",
  secondary: "bg-secondary-100 text-secondary-900 border-secondary-200",
  neutral: "bg-background-100 text-foreground-700 border-background-200",
};

export default function Tag({ children, tone = "neutral" }: TagProps) {
  return (
    <span
      className={`inline-flex items-center rounded-md border px-2 py-0.5 text-xs font-medium whitespace-nowrap ${toneMap[tone]}`}
    >
      {children}
    </span>
  );
}